/**
 * Replaces the timezone of the first date string with the timezone from the second date string.
 *
 * @param {string} date1 - The first date string (e.g., "2024-09-06T00:00:00.000-11:00") whose timezone will be replaced.
 * @param {string} date2 - The second date string (e.g., "2024-09-07T00:00:00.000-07:00") from which the timezone will be extracted.
 * @returns {string} The updated date1 string with the timezone from date2 (e.g., "2024-09-06T00:00:00.000-07:00").
 *
 * @example
 * const date1 = "2024-09-06T00:00:00.000-11:00";
 * const date2 = "2024-09-07T00:00:00.000-07:00";
 * const result = replaceTimezone(date1, date2);
 * console.log(result); // "2024-09-06T00:00:00.000-07:00"
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function replaceTimezone(date1, date2) {
  // Extract the timezone parts from both dates
  const timezone1 = date1.slice(-6) // Extracts the last 6 characters (the timezone)
  const timezone2 = date2.slice(-6)

  // Replace the timezone of date1 with the timezone from date2
  const updatedDate = date1.replace(timezone1, timezone2)

  return updatedDate
}
